const getCssVariable = (name) =>
	getComputedStyle(document.documentElement).getPropertyValue(name).trim()

export const breakpoints = {
	IPHONE_SE: getCssVariable('--iphone_se'),
	PHONE_LARGE: getCssVariable('--phone_large'),
	MOBILE: getCssVariable('--mobile'),
	NOTEBOOK: getCssVariable('--notebook'),
	MOBILE_IFRAME_PLANALTO: getCssVariable('--mobile_iframe_planalto'),
}
